import { render } from "./chat-content.vue?vue&type=template&id=76ef65f0&scoped=true"
import script from "./chat-content.vue?vue&type=script&lang=js"
export * from "./chat-content.vue?vue&type=script&lang=js"

import "./chat-content.vue?vue&type=style&index=0&id=76ef65f0&lang=scss"
import "./chat-content.vue?vue&type=style&index=1&id=76ef65f0&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ef65f0"]])

export default __exports__